import axios, { AxiosRequestConfig } from 'axios'
import formDataHelper from '@/utils/formDataHelper'

axios.defaults.withCredentials = true

class Request {
  async get(url: string, config?: AxiosRequestConfig): Promise<any> {
    let response = await axios.get(url, config)

    if (response.status === 200) {
      return response.data
    }

    return response
  }

  async post(url: string, data: object, hasFile?: boolean, config?: AxiosRequestConfig): Promise<any> {
    if (hasFile) {
      data = formDataHelper.objectToFormData(data)
    }

    return axios.post(url, data, config)
  }

  async put(url: string, data?: any, hasFile?: boolean, config?: AxiosRequestConfig): Promise<any> {
    if (hasFile) {
      data = formDataHelper.objectToFormData(data)

      /** TODO try to find a solution with put method */
      return axios.post(url, data, config)
    }

    return axios.put(url, data, config)
  }

  async delete(url: string, config?: AxiosRequestConfig): Promise<any> {
    return axios.delete(url, config)
  }
}

export default new Request()
